import type { SVGAttributes } from 'react';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps extends SVGAttributes<SVGSVGElement> {
  size?: SpinnerSize;
  label?: string;
}

const SIZE_PX: Record<SpinnerSize, number> = { sm: 14, md: 20, lg: 28 };

export function Spinner({ size = 'md', label = 'Ładowanie…', className, ...rest }: SpinnerProps) {
  const px = SIZE_PX[size];
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      role="status"
      aria-label={label}
      className={['animate-spin text-accent-600', className ?? ''].join(' ')}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        strokeOpacity="0.25"
      />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
